module.exports = __webpack_public_path__ + "img/cash_nl1000-2000.7399cc9c.png";